import { MessagePathNode } from "@/shared/domain/topics";

import { cyclingColorScale } from "./CyclingColorScale";
import { PlotSeries } from "./schema";

/**
 * The color for `series` in the panel `panelId`. The first call takes the
 * panel's next color; later calls for the same series return that color again.
 *
 * The key is the identity `isSameDataSource` (identifiers.ts) compares: the
 * server-assigned `messagePath.id` plus the string form of the path parts.
 * Two series that `isSameDataSource` considers the same therefore always share
 * a color within a panel. A `messagePath.id` is assigned per file, so the same
 * topic name and message path plotted from two different files (one series per
 * recording session, for example) get distinct colors.
 */
export function assignSeriesColor(
  panelId: string,
  series: PlotSeries["data"],
): string {
  const partsString = MessagePathNode.partsToString(series.messagePath.parts);
  return cyclingColorScale.colorFor(
    panelId,
    `${series.messagePath.id}:${partsString}`,
  );
}
